import Vue from 'vue'
import { FilterService} from '@/common/api.service'

import {
    FETCH_FILTER,
    FILTER_UPDATE,
    FILTER_RESET_STATE,
} from './actions.type'

import {
    SET_FILTER,
    RESET_STATE,
} from './mutations.type'

const initialState = {
    filter: {},
}

export const state = Object.assign({}, initialState)

export const actions = {
    [FETCH_FILTER] (context, id) {
        return FilterService.get(id)
        .then(({ data }) => {
            context.commit(SET_FILTER, data)
            return data
        })
    },
    [FILTER_UPDATE] (context, payload) {
        return FilterService.update(payload.type, payload);
    },
    [FILTER_RESET_STATE] ({ commit }) {
        commit(RESET_STATE)
    }
}

export const mutations = {
    [SET_FILTER] (state, filter) {
        state.filter = filter
    },
    [RESET_STATE] () {
        for (let f in state) {
          Vue.set(state, f, initialState[f])
        }
    }
}

const getters = {
    filter (state) {
        return state.filter
    }
  }

export default {
    state,
    actions,
    mutations,
    getters
}